import {ErrorCode} from '../json-rpc-request-wrapper';

export class RpcReceivedError extends Error {
    public code: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public data: any;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message: string, code: number = ErrorCode.SERVER_ERROR, data: any = {}) {
        super(message);
        Object.setPrototypeOf(this, RpcReceivedError.prototype);
        this.name = 'RpcReceivedError';
        this.code = code;
        this.data = data;
    }
}
